const T=5e3,_=10;export{T as STORY_DETAIL_LIST_DURATION,_ as STORY_DETAIL_LIST_PROGRESS_INTERVAL};
